import { render, staticRenderFns } from "./DestinationsSearch.vue?vue&type=template&id=3a3823ac&lang=pug&"
import script from "./DestinationsSearch.vue?vue&type=script&lang=js&"
export * from "./DestinationsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports